function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Power_Point",
  "data-name": "Power Point",
  fill: "#ce4123",
  stroke: "#ce4022",
  strokeWidth: "4px",
  className: "cls-1",
  d: "M8.2-43.66a7.053,7.053,0,0,0-.154-1.582A2.338,2.338,0,0,0,7.5-46.318a2.271,2.271,0,0,0-1.066-.615,6.359,6.359,0,0,0-1.736-.2,26.789,26.789,0,0,0-3.713.33L.725-48.757q2.065-.374,4.515-.769t5.032-.725q2.582-.33,5.186-.538t5-.209a29.5,29.5,0,0,1,5.944.571,13.711,13.711,0,0,1,4.856,1.945,9.743,9.743,0,0,1,3.285,3.68,12.318,12.318,0,0,1,1.208,5.757A18.379,18.379,0,0,1,34.4-31.827a15.231,15.231,0,0,1-3.79,5.416,16.605,16.605,0,0,1-5.856,3.395A23.078,23.078,0,0,1,17.2-21.841a2.2,2.2,0,0,1-1.3-.286,1.518,1.518,0,0,1-.374-1.23v-.286a1.82,1.82,0,0,1,.022-.33,20.145,20.145,0,0,0,5.548-.67,13.074,13.074,0,0,0,3.9-1.78,9.631,9.631,0,0,0,2.527-2.527,12.348,12.348,0,0,0,1.45-2.922,13.87,13.87,0,0,0,.659-2.977,25.812,25.812,0,0,0,.154-2.659,13.771,13.771,0,0,0-.89-5.306,8.526,8.526,0,0,0-2.417-3.373,9.041,9.041,0,0,0-3.571-1.769,17.706,17.706,0,0,0-4.351-.516q-1.165,0-2.23.088t-2.318.242q-.044,1.692-.121,4.526T13.722-37.1q-.1,3.68-.231,8.064t-.264,9.163q-.132,4.779-.286,9.822T12.634,0L7.427.659l-.4-.044q.264-6.306.483-11.953t.363-11q.143-5.35.231-10.591T8.2-43.66Z",
  transform: "translate(0.953 52.499)"
});

var SvgPptx = function SvgPptx(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 38.203 54.668",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPptx, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pptx.aa2134a0.svg";
export { ForwardRef as ReactComponent };